import { Link } from '@/atoms/Link';
import { Text } from '@/atoms/Text/Text';
import { RouterLink } from '@/components/Atoms/RouterLink/RouterLink';
import { Heading } from '@/components/Auth/typography';

export const CardHeader = ({
  title,
  to,
  text,
  linkLabel,
  center,
}: CardHeaderProps) => {
  const isAbsolute = to?.startsWith('http');

  return (
    <div className='flex flex-col'>
      <Heading center={center}>{title}</Heading>
      <div className='flex gap-2'>
        <Text>{text}</Text>
        {to ? (
          isAbsolute ? (
            <Link href={to} target='_self' underline>
              {linkLabel}
            </Link>
          ) : (
            <RouterLink to={to} color='emerald' dark>
              {linkLabel}
            </RouterLink>
          )
        ) : null}
      </div>
    </div>
  );
};

type CardHeaderProps = {
  title: string;
  to?: string;
  text?: string;
  linkLabel?: string;
  center?: boolean;
};
